import React, { Component } from 'react';
import './style.scss';
import { MODAL_PRESENTATION_DELETE, showModal, MODAL_PRESENTATION_FORM, MODAL_PRESENTATION_COPY } from '../../../../../../modules/modals';
import {Link} from 'react-router-dom'
import history from '../../../../../../history';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux'
import { getFolderPresentation } from '../../../../actions';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';

class Item extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      played: false,
      stop: true,
      isCloseLoaded: false,
    }
  }

  render() {
    const {presentation, urlApi, showModal, siteUrl} = this.props;
    const {stop, isCloseLoaded} = this.state;
    const {formatMessage} = this.context;

    return (
      <div className="col-md-4 Item" 
        
      >
        <div className="item-container" style={{cursor: 'pointer'}} onClick={() => {
          if(!presentation.started){
            history.push('/presentation/' + presentation.id)
          }
        }}>
          <div className="item-content" 
            onMouseEnter ={(e) => {
              e.stopPropagation();
              const {folder} = this.props;
              this.props.getFolderPresentation(folder.id, true)
            }}
          >
            {!presentation.started && <div className="icon-delete" onClick={(e)=>{
              e.stopPropagation();
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_PRESENTATION_DELETE,
                modalProps : {
                  id: presentation.id
                }
              });
            }}>
              <i className="fas fa-times"></i>
            </div>}
            {!presentation.started && <div className="icon-setting" onClick={(e) => {
              e.stopPropagation();
              history.push('/presentation/' + presentation.id)
            }}>
              <i className="fas fa-cog"></i>
            </div>}
            <div className="icon-link" onClick={(e) => {
              e.stopPropagation();
              var copyText = document.getElementById("copy-link" + presentation.id);

              /* Select the text field */
              copyText.select();
              copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            
              /* Copy the text inside the text field */
              document.execCommand("copy");
              toastr.success(formatMessage('linkMessage'), formatMessage('linkMsgCopy'))
            }}>
              <input id={"copy-link" + presentation.id} style={{opacity: 0, width: 1, zIndex: -1, position: 'absolute'}} value={siteUrl  + '/presentation/' + presentation.token_student} />
              <i style={{zIndex: 99}} className="fas fa-link"></i>
            </div>
            {!presentation.started && <div className="icon-setting edit" onClick={(e) => {
              e.stopPropagation();
              showModal({
                modalType : MODAL_PRESENTATION_FORM,
                modalProps : {
                  initialValues: presentation,
                  siteUrl
                }
              });
            }}>
              <i className="fas fa-pencil-alt"></i>
            </div>}
            {!presentation.started && <div style={{right: 27}} className="icon-setting edit" onClick={(e) => {
              e.stopPropagation();
              showModal({
                modalType : MODAL_PRESENTATION_COPY,
                modalProps : {
                  pr_id: presentation.id,
                  initialValues: presentation
                }
              });
            }}>
              <i className="far fa-copy"></i>
            </div>}
            <div className="block" style={{backgroundImage: presentation.first_slider ? `url(${presentation.first_slider.src})` : 'none'}}>
              <p onClick={(e) => {e.stopPropagation();}} style={{background: "#00adff", cursor: 'default',  padding: '3px 12px', color: 'white'}}> {presentation.code}</p>
              <div className="play" onClick={(e) => {
                e.stopPropagation();
                history.push('/presentations_start/' + presentation.id)
              }}>
                <i className="fas fa-play"></i>
              </div>
              <p> {presentation.started ? 
                <button 
                  className={classNames("label", {'label-success': stop, 'label-danger': !stop})} 
                  onMouseMove={(e) => {this.setState({stop: false})}} 
                  onMouseOut={(e) => {this.setState({stop: true})}}
                  onClick={(e) => {
                    e.stopPropagation();
                    const {folder} = this.props;
                    if(this.state.isCloseLoaded){
                      return;
                    }
                    this.state.isCloseLoaded = true;
                    fetch(urlApi + '/api/presentations/closed?session=' + presentation.session_id + '&date=' + moment().format('MM-DD-YYYY h:mm a')).then(response => {
                      this.state.isCloseLoaded = false;
                      this.props.getFolderPresentation(folder.id)
                    })
                  }}
                >
                  {stop ? formatMessage('startedPresent') : formatMessage('stopPresent')}
                </button> : formatMessage('startPresent')} </p>
            </div>
          </div>
        </div>
        <div className="title-pres" title={presentation.name}>{presentation.name}</div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  folder: state.folders.item,
})

const mapDispatchToProps = {
  getFolderPresentation,
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/PresentationItems/components/Item/Item.jsx